module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/msysov3-910e1abfc0ae058c158d537590d91165.jpg";